<template>
<div class="erco-cms-structure-dropdown d-inline-block">
	<!-- <span v-if="selectionInfo" class="selection-info mr-2" v-html="selectionInfo"></span> -->
	<div class="dropdown-label-box d-inline-block my-2 my-lg-0">
		<div :class="['dropdown', 'btn-group', { 'show': visible }]">
			<button type="button"
			        class="btn btn-secondary dropdown-toggle"
			        ref="mainDropdownButton"
			        @click="handleButtonClick"
			        @blur="handleBlur">
		        <span></span>
		        <span></span>
		        <span></span>
			</button>
			<div role="menu"
			     class="dropdown-menu">
				<a :href="lightscoutURL"
				   class="dropdown-item"
				   role="menuitem">
				   Live-Auswahl
				</a>
				<a href="javascript: void(0);"
				   class="dropdown-item"
				   role="menuitem"
				   @click="handleSubmenuItemClick"
				   @blur="handleBlur">
				   CMS-Struktur
					<div class="dropdown dropdown-sub btn-group">
						<div role="menu"
						     class="dropdown-menu">
							<a href="javascript: void(0);"
							   class="dropdown-item -muted text-muted"
							   role="menuitem"
							   @click="handleSubmenuItemClick"
							   @blur="handleBlur">
								<strong>Bereich</strong>
							</a>
							<a href="javascript: void(0);"
							   class="dropdown-item dropdown-static-item"
							   role="menuitem"
							   @click="handleResetClick">
							   Auswahl zurücksetzen
							</a>
							<a v-for="(category, cIndex) in dataset"
							   :key="cIndex"
							   href="javascript: void(0);"
							   :class="['dropdown-item', 'dropdown-multilevel-item', {'-active': itemIsActive({ category: category.name })}]"
							   role="menuitem"
							   @click="handleSubmenuItemClick"
							   @blur="handleBlur">
								<div class="dropdown dropdown-sub">
									<a aria-disabled="false"
									   class="dropdown-item"
									   role="menuitem"
									   @click="handleSubmenuItemClick"
									   @blur="handleBlur">
										{{category.name}}
									</a>
									<div role="menu"
									     class="dropdown-menu">
										<a href="javascript: void(0);"
										   class="dropdown-item -muted text-muted"
										   role="menuitem"
										   @click="handleSubmenuItemClick"
										   @blur="handleBlur">
										   <strong>Spezifikation</strong>
										</a>
										<a v-for="(specification, sIndex) in category.spezifikationen"
										   :key="sIndex"
										   :class="['dropdown-item', 'dropdown-multilevel-item', {'-active': itemIsActive({ category: category.name, specification: specification.name })}]"
										   role="menuitem"
										   @click="handleSubmenuItemClick"
										   @blur="handleBlur">
											<div class="dropdown dropdown-sub">
												<a href="javascript: void(0);"
												   class="dropdown-item"
												   role="menuitem"
												   @click="handleSubmenuItemClick"
												   @blur="handleBlur">
													{{specification.name}}
												</a>
												<div role="menu"
												     class="dropdown-menu -last">
													<a href="javascript: void(0);"
													   class="dropdown-item -muted text-muted"
													   role="menuitem"
													   @click="handleSubmenuItemClick"
													   @blur="handleBlur">
														<strong>Gattung</strong>
													</a>
													<a v-for="(genus, gIndex) in specification.gattungen"
													   href="javascript: void(0);"
													   :key="gIndex"
													   :class="['dropdown-item', 'dropdown-last-item', {'-active': itemIsActive({ category: category.name, specification: specification.name, genus: genus.name })}]"
													   role="menuitem"
												   	   @mousedown="handleGenusClick(category.name, specification.name, genus.name, $event)">
														{{genus.name}}
													</a>
												</div>
											</div>
										</a>
									</div>
								</div>
							</a>
						</div>
					</div>
				</a>
			</div>
		</div>
	</div>
</div>
</template>

<script>

	export default {
		name: 'ErcoCmsStructureDropdownAtom',

		props: {
			dataset: {
				type: Object,
				required: true,
			},
		},

		data() {
			return {
				visible: false,
			};
		},

		computed: {
			lightscoutURL() {
				/* TODO: Sprung zu Live-Auswahl */
				return process.env.LS2014_SERVER;
			},
			selectionInfo() {
				if (Object.keys(this.currentSelection).length === 0) {
					return '';
				}
				return `${this.currentSelection.category}
				        <span class="divider">-</span> ${this.currentSelection.specification}
				        <span class="divider">-</span> ${this.currentSelection.genus}`;
			},
			currentSelection() {
				return (this.$store.state.dashboard.activeFilters.cmsStructure &&
				        this.$store.state.dashboard.activeFilters.cmsStructure.value) || {};
			},
		},

		methods: {
			itemIsActive(pairs) {
				return Object.keys(pairs).reduce((acc, key) => {
					const value = pairs[key];
					return acc && (this.currentSelection[key] === value);
				}, true) && Object.keys(pairs).length > 0;
			},

			handleButtonClick() {
				this.visible = !this.visible;
			},
			handleBlur(event) {
				if (event.relatedTarget && event.relatedTarget.classList.contains('dropdown-item')) {
					this.$refs.mainDropdownButton.focus();
					return;
				}

				if (this.visible) {
					this.visible = !this.visible;
				}
			},
			handleSubmenuItemClick() {
				return false;
			},
			handleGenusClick(category, specification, genus) {
				this.$emit('click', {
					category,
					specification,
					genus,
				});
				this.visible = false;
				return false;
			},
			handleResetClick() {
				this.$emit('click', null);
				this.visible = false;
			},
		},
	};

</script>

<style lang="scss">

.erco-cms-structure-dropdown {
	> .selection-info {
		vertical-align: middle;

		.divider {
			color: rgba(99, 108, 114, 0.5);
			margin: 0 0.2rem;
		}
	}

	> .dropdown-label-box {
		> .dropdown {
			> .dropdown-menu {
				> .dropdown-item {
					> .dropdown-sub {
						padding: 0;
					}
				}
			}
		}
	}

	.dropdown {
		margin-top: 0;
		padding: 0.2rem 0;

		&.btn-group {
			.dropdown-menu {
				right: 0;
			}
		}

		& > a {
			color: inherit;
		}

		& > .dropdown-toggle {
			height: 2.5rem;
			border-color: transparent;

			&::after {
				border: 0;
			}

			> span {
				&:first-child {
					margin-top: 0.1rem;
				}

				border-bottom: 2px solid rgba(99, 108, 114, 1);
				display: block;
				width: 1.5rem;
				margin: 0.35rem 0;
			}
		}

		.dropdown-menu {
			left: auto;

			&.-last {
				left: 100%;
				right: auto !important;
				border-top-left-radius: 0;
				border-top-right-radius: 4px !important;
			}
		}

		.dropdown-item {
			&.-active {
				color: #fff;
    			background-color: rgba(2, 117, 216, 1);
			}
			&:hover {
				&.-muted {
					&:active,
					&:hover {
						color: rgba(99, 108, 114, 1);
						background-color: #fff;
					}
				}
				&:not(.-muted) {
					color: #fff;
	    			background-color: rgba(2, 117, 216, 1);
				}

				& > .dropdown-sub {
					& > .dropdown-menu {
						display: block;
						right: 100%;
						top: -1.5rem;
						border-top-right-radius: 0;
					}
				}
			}
		}

		.dropdown-last-item {
			padding: 0.4rem 1rem 0.4rem 2.5rem;
			position: relative;
		}

		.dropdown-multilevel-item {
			padding: 0;
			padding-left: 1rem;
			padding-right: 1rem;
			position: relative;

			&:after {
				position: absolute;
				width: 0;
				height: 0;
				margin-left: 0.3em;
				vertical-align: middle;
				content: "";
				border-top: 0.3em solid;
				border-right: 0.3em solid transparent;
				border-left: 0.3em solid transparent;
				top: 50%;
				left: 0.5rem;
				transform: rotate(90deg);
			}
		}

	.dropdown-sub:not(.btn-group) {
		.dropdown-multilevel-item {
			&:after {
				left: auto;
				right: 1rem;
				transform: rotate(-90deg);
			}
		}
	}

		.dropdown-static-item {
			padding-left: 2.5rem;
		}
	}
}

</style>



// WEBPACK FOOTER //
// ErcoCmsStructureDropdown.vue?51d42d68